import React, { useState } from 'react';
import { api } from '../utils/api';

function Track() {
  const [orderId, setOrderId] = useState('');
  const [customerName, setCustomerName] = useState('');
  const [customerPhone, setCustomerPhone] = useState('');
  const [order, setOrder] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleTrack = async (e) => {
    e.preventDefault();
    setError('');
    setOrder(null);
    setLoading(true);

    try {
      // Search by tracking ID
      const response = await fetch(`${api.baseURL}/orders.php?tracking_id=${orderId}&customer_name=${encodeURIComponent(customerName)}&customer_phone=${encodeURIComponent(customerPhone)}`);
      const orderDetails = await response.json();
      
      if (orderDetails && orderDetails.id) {
        setOrder(orderDetails);
      } else {
        setError('Order not found. Please check your Tracking ID, Name, and Phone Number.');
      }
    } catch (err) {
      setError('Failed to fetch order. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    switch(status) {
      case 'delivered': return '#4caf50';
      case 'out_for_delivery': return '#00bcd4';
      case 'shipped': return '#2196f3';
      case 'packed': return '#03a9f4';
      case 'processing': return '#9c27b0';
      case 'confirmed': return '#8bc34a';
      case 'cancelled': return '#f44336';
      case 'returned': return '#ff5722';
      default: return '#ff9800';
    }
  };

  return (
    <div className="container" style={{padding: '40px 20px', minHeight: '70vh'}}>
      <div style={{maxWidth: '800px', margin: '0 auto', animation: 'fadeInUp 0.6s ease'}}>
        <h1 style={{textAlign: 'center', marginBottom: '30px', color: '#333'}}>Track Your Order</h1>
        
        <form onSubmit={handleTrack} style={{marginBottom: '40px'}}>
          <div style={{maxWidth: '600px', margin: '0 auto'}}>
            <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '12px', marginBottom: '12px'}}>
              <input
                type="text"
                placeholder="Tracking ID (FE-XXXX) *"
                value={orderId}
                onChange={(e) => setOrderId(e.target.value)}
                required
                style={{
                  padding: '12px 16px',
                  fontSize: '16px',
                  border: '2px solid #ddd',
                  borderRadius: '4px',
                  outline: 'none',
                  width: '100%'
                }}
              />
              <input
                type="text"
                placeholder="Full Name *"
                value={customerName}
                onChange={(e) => setCustomerName(e.target.value)}
                required
                style={{
                  padding: '12px 16px',
                  fontSize: '16px',
                  border: '2px solid #ddd',
                  borderRadius: '4px',
                  outline: 'none',
                  width: '100%'
                }}
              />
              <input
                type="tel"
                placeholder="Mobile Number *"
                value={customerPhone}
                onChange={(e) => setCustomerPhone(e.target.value)}
                required
                style={{
                  padding: '12px 16px',
                  fontSize: '16px',
                  border: '2px solid #ddd',
                  borderRadius: '4px',
                  outline: 'none',
                  width: '100%'
                }}
              />
            </div>
            <button
              type="submit"
              disabled={loading || !orderId || !customerName || !customerPhone}
              style={{
                width: '100%',
                padding: '12px 32px',
                fontSize: '16px',
                fontWeight: '600',
                background: '#2196f3',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                cursor: (loading || !orderId || !customerName || !customerPhone) ? 'not-allowed' : 'pointer'
              }}
            >
              {loading ? 'Tracking...' : 'Track Order'}
            </button>
          </div>
        </form>

        {error && (
          <div style={{
            padding: '16px',
            background: '#ffebee',
            color: '#c62828',
            borderRadius: '4px',
            marginBottom: '20px',
            textAlign: 'center'
          }}>
            {error}
          </div>
        )}

        {order && (
          <div style={{
            background: '#fff',
            border: '1px solid #e0e0e0',
            borderRadius: '8px',
            padding: '24px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
          }}>
            <div style={{borderBottom: '2px solid #f0f0f0', paddingBottom: '16px', marginBottom: '20px'}}>
              <h2 style={{margin: '0 0 8px 0', color: '#333'}}>Order {order.tracking_id}</h2>
              <div style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
                <span style={{fontSize: '14px', color: '#666'}}>Status:</span>
                <span style={{
                  padding: '6px 16px',
                  borderRadius: '20px',
                  background: getStatusColor(order.status),
                  color: '#fff',
                  fontWeight: '600',
                  fontSize: '14px',
                  textTransform: 'uppercase'
                }}>
                  {order.status}
                </span>
              </div>
            </div>

            <div style={{marginBottom: '24px'}}>
              <h3 style={{marginBottom: '12px', color: '#555'}}>Customer Details</h3>
              <div style={{display: 'grid', gap: '8px'}}>
                <div><strong>Name:</strong> {order.customer_name || 'N/A'}</div>
                <div><strong>Phone:</strong> {order.customer_phone || 'N/A'}</div>
                <div><strong>Email:</strong> {order.customer_email || 'N/A'}</div>
                <div><strong>Address:</strong> {order.customer_address || 'N/A'}</div>
                <div><strong>Order Date:</strong> {new Date(order.created_at).toLocaleString()}</div>
              </div>
            </div>

            <div>
              <h3 style={{marginBottom: '12px', color: '#555'}}>Order Items</h3>
              {order.items && order.items.length > 0 ? (
                <div>
                  {order.items.map((item, index) => (
                    <div key={index} style={{
                      display: 'flex',
                      flexDirection: window.innerWidth <= 768 ? 'column' : 'row',
                      justifyContent: 'space-between',
                      padding: '12px',
                      background: '#f9fafb',
                      marginBottom: '8px',
                      borderRadius: '4px',
                      gap: '8px'
                    }}>
                      <div>
                        <div style={{fontWeight: '600', marginBottom: '4px'}}>{item.product_name}</div>
                        <div style={{fontSize: '14px', color: '#666'}}>
                          Quantity: {item.quantity} × Rs. {item.price}
                        </div>
                      </div>
                      <div style={{fontWeight: '700', color: '#2196f3'}}>
                        Rs. {(item.price * item.quantity).toFixed(2)}
                      </div>
                    </div>
                  ))}
                  <div style={{
                    textAlign: 'right',
                    marginTop: '16px',
                    padding: '12px',
                    background: '#e8f0fe',
                    borderRadius: '4px'
                  }}>
                    <strong style={{fontSize: '18px'}}>Total: Rs. {order.total}</strong>
                  </div>
                </div>
              ) : (
                <p>No items found</p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Track;
